import Insight from "../insightClass";
import React from "react";
import { insight35Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight062 = new Insight(
  "5 September 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight35Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-09-05)",
  "",
  `The UK government has granted development consent for the 1.5 GW Morgan Offshore Wind Project, located approximately 30 miles off Liverpool. The development, backed by JERA, EnBW, and BP, will feature 96 turbines of 14 MW each and aims for completion by 2030. The Planning Inspectorate’s review progressed swiftly, reflecting a well-prepared submission and effective stakeholder engagement.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-09-05)</h1>
    <h2></h2>
    <p className="article-date">5 September 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. UK greenlights 1.5 GW Morgan Offshore Wind Project in the Irish Sea
    </h3>
    <p>
      The UK government has granted development consent for the 1.5 GW Morgan
      Offshore Wind Project, located approximately 30 miles off Liverpool. The
      development, backed by JERA, EnBW, and BP, will feature 96 turbines of 14
      MW each and aims for completion by 2030. The Planning Inspectorate’s
      review progressed swiftly, reflecting a well-prepared submission and
      effective stakeholder engagement. This approval comes at a critical time
      for the UK offshore sector, which has faced uncertainty due to
      inflationary pressures and supply-chain delays, and it signals renewed
      momentum in achieving the UK’s 2030 clean energy ambitions.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Morgan’s approval reinforces confidence in the UK’s consenting framework
      and showcases the benefits of early-stage stakeholder management. The
      project’s North West location places significant emphasis on strengthening
      grid capacity in a region already under strain, highlighting the urgent
      need for proactive reinforcement and curtailment strategies. Turbine sizes
      of 14 MW also indicate a trend towards higher-capacity machines that
      optimise LCOE but increase logistical demands, especially on heavy-lift
      vessel availability. As AR6 auction results improve, this project’s
      financial close outlook is bolstered, but developers will need to
      carefully plan around port upgrades, vessel access, and long-lead
      procurement to stay on schedule.
    </p>
    <h3>2. Dogger Bank C: inter-array cable installation mobilises</h3>
    <p>
      Cable installation has commenced at Dogger Bank C, the final phase of what
      will be the world’s largest offshore wind complex. DEME’s Viking Neptun
      has been deployed to lay around 155 miles of 66 kV inter-array cables
      supplied by Hellenic Cables. This marks a major milestone following
      substation and monopile installation earlier this year, with full
      commissioning targeted for 2027. The campaign comes amid tight vessel
      availability and heightened scrutiny of inter-array cable performance,
      given recent industry-wide reliability issues.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This installation campaign is a pivotal test of offshore logistics
      coordination in a crowded North Sea construction environment. Successful
      cable-lay operations will de-risk the project’s critical path and validate
      lessons learned from earlier phases. The integration of advanced
      monitoring technology is expected to mitigate early-life cable failures,
      setting a benchmark for reliability. Any schedule slippage here could
      cascade across the multi-phase Dogger Bank portfolio, underlining the
      strategic value of proactive interface and risk management strategies that
      developers will increasingly adopt for large-scale offshore complexes.
    </p>
    <h3>
      3. Ørsted secures up to DKK 6bn (~$941m) from Equinor in DKK 60bn rights
      issue; Norway’s oil fund supportive
    </h3>
    <p>
      Ørsted has secured a substantial commitment from Equinor, which will
      invest up to DKK 6bn (~$941m) in its DKK 60bn capital raise. Norway’s
      sovereign wealth fund has also pledged support, strengthening confidence
      in Ørsted’s balance sheet amid cost escalations and US market volatility.
      This recapitalisation reflects a shift toward strategic collaboration,
      with Equinor gaining greater influence over Ørsted’s portfolio decisions
      as the industry adjusts to elevated interest rates and tightening capital
      markets.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This capital raise underscores a pivotal consolidation moment for the
      offshore wind sector, where developers are seeking partners with
      integrated trading and project execution expertise. Equinor’s involvement
      may prompt a portfolio rationalisation, focusing Ørsted’s efforts on more
      predictable European revenue models while cautiously reassessing US
      expansion. Procurement strategies will now emphasise long-lead cost
      hedging, especially for critical components such as HVDC systems and
      monopiles. This alignment strengthens Ørsted’s credibility with lenders
      and suppliers, setting a precedent for future partnerships that balance
      financial discipline with growth ambitions.
    </p>
    <h3>
      4. Poland accelerates Baltic offshore build-out; foreign capital pours in
    </h3>
    <p>
      Poland is rapidly scaling its offshore wind ambitions, targeting 6 GW by
      2030 and up to 18 GW by 2040. The €4.7bn Baltic Power project, a joint
      venture between Orlen and Northland Power, will install 76 turbines by
      2026. Global players like Ørsted, RWE, Siemens Gamesa, and Ocean Winds are
      increasing investment in Polish ports and supply-chain infrastructure,
      positioning the country as a Baltic hub. This expansion reflects Poland’s
      determination to reduce dependence on Russian energy imports and establish
      a renewable energy leadership role in the region.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Poland’s scale-up will create a new gravitational centre for offshore wind
      investment in Europe, diversifying supply chains beyond the traditional
      North Sea bases. Challenges will include Baltic weather constraints and
      port capacity limitations, but aggressive government support and
      localisation efforts should attract sustained foreign capital. For
      developers and OEMs, strategic planning in Gdansk and Gdynia could reduce
      transport bottlenecks, while regional grid integration with neighbouring
      Baltic states will unlock higher utilisation rates. Poland’s entry signals
      that new offshore wind clusters are maturing quickly and will increasingly
      influence European logistics, vessel deployment strategies, and component
      sourcing.
    </p>
    <h3>
      5. US policy shock: Administration moves to reconsider SouthCoast Wind
      permit
    </h3>
    <p>
      The US administration has indicated plans to remand SouthCoast Wind’s
      construction and operations plan for reconsideration, following a lawsuit
      by the town of Nantucket. The decision raises concerns about the stability
      of the permitting regime for offshore wind, as SouthCoast Wind, a 1.2 GW
      project backed by Ocean Winds, is seen as a bellwether for the US
      industry. The review could delay critical path elements such as
      transmission interconnection and cable installation schedules, threatening
      to disrupt momentum in the US offshore market.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The move highlights regulatory unpredictability that could deter investors
      and complicate financing strategies. Developers will increasingly
      structure contracts with robust change-in-law provisions and delay buffers
      to protect financial exposure. Transmission staging and port readiness
      plans may need to be revised to preserve optionality, especially for
      multi-phase developments like SouthCoast. This situation underscores the
      importance of diversified regional pipelines, as companies may pivot
      investment focus back to Europe and Asia until a more consistent US
      regulatory framework is established.
    </p>
    <h3>6. US cuts $679m in federal support for 12 offshore wind projects</h3>
    <p>
      Federal authorities have cancelled $679m in awards for 12 offshore wind
      projects and port developments, including significant funding for
      terminals in California, New Jersey, and Massachusetts. The decision
      delivers a major blow to the sector’s infrastructure pipeline, slowing
      localisation efforts for turbines and components, and threatening project
      timelines. Industry stakeholders warn this may weaken job creation and
      domestic manufacturing ambitions tied to the Inflation Reduction Act’s
      incentives.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Removing critical funding for port upgrades could create severe knock-on
      effects for project economics and schedules. Without expanded domestic
      pre-assembly and heavy-lift capacity, developers may face higher costs
      from importing components and longer tow-out distances. OEMs are likely to
      prioritise existing European and Asian manufacturing hubs, slowing US
      localisation momentum. Financial institutions will demand stronger port
      contingency plans and larger cost reserves, making project structuring
      more complex. This underlines how political volatility can shape capital
      allocation decisions, highlighting the need for bipartisan support to
      stabilise offshore wind’s growth trajectory in the US.
    </p>
    <h3>
      7. Australia completes landfall site surveys for Ørsted export cable route
    </h3>
    <p>
      Ørsted has finished a seven-week geotechnical and oceanographic survey in
      Australia’s Gippsland region, gathering data critical to finalising export
      cable routing for a future offshore wind farm. The campaign investigated
      seabed conditions, sediment profiles, and landfall characteristics, laying
      groundwork for engineering and permitting. Australia’s offshore wind
      sector is in its infancy, and Gippsland is seen as a strategic anchor for
      the country’s renewable ambitions, with developers like Ørsted seeking
      early-mover advantages.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This survey marks an important step for Australia’s offshore wind sector,
      providing Ørsted and its partners with data to refine engineering choices
      and derisk future tenders. Detailed site intelligence enhances bankability
      by reducing uncertainty premiums for lenders and insurers, while also
      streamlining environmental approval processes with regulators and local
      stakeholders. Early data-driven planning gives Ørsted a competitive edge
      in vessel scheduling and cable-lay contracting, which will be crucial as
      Australia ramps up activity in a relatively underdeveloped maritime
      infrastructure environment. This project demonstrates how proactive
      technical studies can accelerate market development in emerging offshore
      wind regions and serve as a template for industry best practices.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
